import { useAccount } from "wagmi";
import moment from "moment";
import ReactGA from "react-ga";

import { ReactCarousel, ReactCarouselItem } from "@bracket/react-carousel";
import { Tab, TabPanel } from "@bracket/react-tabs";
import { useEscrowStore } from "@stores/escrow";
import { usePointsStore } from "@stores/points";
import { getTimedImageLoc } from "@helpers";
import { SectionHeading } from "@components";
import { SetStake } from "./Set";
import { SwapStake } from "./Swap";
import { Unstake } from "./Unstake";

import "./Stake.scss";

import { useEffect, type FunctionComponent, type ReactElement } from "react";

export const Stake: FunctionComponent = (): ReactElement => {
  ReactGA.pageview(window.location.pathname);

	const ARBITRUM_DEADLINE = "2025-01-14T09:00:00-05:00";
	const MAINNET_DEADLINE = "2025-01-21T09:00:00-05:00";

	const { address, chainId, } = useAccount();
  const { swapping } = useEscrowStore();
  const arbitrumLocked = chainId === 42161 && moment(ARBITRUM_DEADLINE).isBefore(moment());
  const mainnetLocked = chainId === 1 && moment(MAINNET_DEADLINE).isBefore(moment());
  const carouselDeferred = true;

  if(arbitrumLocked ) {
		let title = "Phase I is coming to an end!";
		let message = "In preparation for the brktETH claim, Arbitrum deposits and withdrawals are locked until the 28th of January to allow for bridging to Ethereum mainnet. Your brktETH will be available to claim on Ethereum mainnet at Phase II launch on January 28th.";
    if(mainnetLocked) {
			title = "Phase I is now concluded!"
      message = "Assets on both Arbitrum and Ethereum mainnet are locked in preparation for brktETH claim on the 28th of January."
		}
		return (
      <section className="stake">
        {!isMobile() && <SectionHeading name="" />}
        <div className="locked-panel">
          <p className="locked-title">{title}</p>
          <p className="locked-message">{message}</p>
          <p className="locked-signed">Bracket Team</p>
        </div>
        {isMobile() && <SectionHeading name="" />}
      </section>
    );
  }

  if(mainnetLocked ) {
    const title = "Phase I is now concluded!"
    const message = "Assets on both Arbitrum and Ethereum mainnet are locked in preparation for brktETH claim on the 28th of January."
		return (
      <section className="stake">
        {!isMobile() && <SectionHeading name="" />}
        <div className="locked-panel">
          <p className="locked-title">{title}</p>
          <p className="locked-message">{message}</p>
          <p className="locked-signed">Bracket Team</p>
        </div>
        {isMobile() && <SectionHeading name="" />}
      </section>
    );
  }

  return (
    <section className="stake">
      <SectionHeading name="Stake">
        <p className="stake-blurb">
          Earn ETH rewards + Bracket Points + Supported LRT Points when you
          stake.
        </p>
      </SectionHeading>
      {carouselDeferred ? (
        <div className="padder" />
      ) : (
        <ReactCarousel>
          <ReactCarouselItem>
            <img
              className="broken-banner"
              src={getTimedImageLoc()}
              width="auto"
              alt="stake rs-eth"
            />
          </ReactCarouselItem>
        </ReactCarousel>
      )}
      <section className="status-detail">
        {address ? (
          <TabPanel>
            <Tab
              label="Stake"
              component={swapping ? SwapStake : SetStake}
              route="/stake/stake"
            />
            <Tab label="Balances" component={Unstake} route="/stake/balances" />
          </TabPanel>
        ) : null}
      </section>
    </section>
  );
};


function isMobile() {
  if((navigator as any).userAgentData && (navigator as any).userAgentData.mobile) {
    return true;
  } else {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
